import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import DashboardTemplate from "../../templates/Dashboard";
import { useAppSelector } from "../../config/hooks";

export default function Home() {
  const navigate = useNavigate();
  const myProfileData = useAppSelector((state) => state?.myProfile?.userData);

  useEffect(() => {
    if (myProfileData?.data?.type) {
      if (myProfileData?.data?.type?.toLowerCase() === "super_admin") {
        navigate("/companies");
      } else if (myProfileData?.data?.type.toLowerCase() !== "super_admin") {
        navigate(`/company-settings/${myProfileData?.data?.company_id}`);
      }
    }
  }, [navigate, myProfileData?.data]);

  return <DashboardTemplate loading={myProfileData?.loader} />;
}
